// بنفس ستايل POList اللي بعتهولي
import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Plus, Search, ShieldAlert } from 'lucide-react';

const HazardList = () => {
  const [hazards, setHazards] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/hazards').then(res => setHazards(res.data.data || []));
  }, []);

  const filteredData = useMemo(() => hazards.filter(h => 
    h.hazardnum.toLowerCase().includes(searchTerm.toLowerCase()) || h.description.toLowerCase().includes(searchTerm.toLowerCase())
  ), [hazards, searchTerm]);

  return (
    <div className="flex flex-col h-full bg-[#f3f4f6] text-[11px] font-sans uppercase">
      <div className="bg-white p-3 border-b shadow-sm flex justify-between items-center">
        <h2 className="text-[#005495] font-black italic uppercase text-lg flex items-center gap-2"><ShieldAlert size={20}/> Hazards Master</h2>
        <div className="flex gap-4">
          <div className="relative"><Search className="absolute left-3 top-2 text-gray-400" size={14} /><input className="pl-9 pr-4 py-1.5 border border-gray-300 w-80 outline-none rounded-sm font-bold" placeholder="Search Hazard..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)}/></div>
          <button onClick={() => navigate('/hazards/new')} className="bg-[#3c70a4] text-white px-6 py-2 rounded-sm font-bold flex items-center gap-2 shadow-md"><Plus size={16}/> NEW HAZARD</button>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-4">
        <div className="bg-white border shadow-sm">
          <table className="w-full text-left">
            <thead className="bg-[#f9fafb] border-b text-gray-400 font-bold uppercase sticky top-0">
              <tr><th className="p-2 border-r">Hazard Num</th><th className="p-2 border-r">Description</th><th className="p-2 text-center">Type</th></tr>
            </thead>
            <tbody>
              {filteredData.map((h, i) => (
                <tr key={i} className="border-b hover:bg-blue-50 cursor-pointer font-bold" onClick={() => navigate(`/hazards/${h.hazardnum}`)}>
                  <td className="p-2.5 border-r text-blue-900 font-black">{h.hazardnum}</td>
                  <td className="p-2.5 border-r text-gray-600">{h.description}</td>
                  <td className="p-2.5 text-center text-orange-600 font-black">{h.hazardtype}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HazardList;
